export default __webpack_public_path__ + "static/media/rentatoy-logo-white.402ac013.png";